module.exports = __webpack_public_path__ + "static/media/skullAndCrossBones.aa58e99a.png";